import { Flex, TextVariant, Text } from '@mprolab/uikit'
import * as React from 'react'
import UseAnimations from 'react-useanimations'
import loading from 'react-useanimations/lib/loading'
import styled, { useTheme } from 'styled-components'

interface IAppProps {
  label: string
  value: number | string
  valueType?: string
  valueColor?: string
  labelColor?: string
  isLoading?: boolean
  isLast?: boolean
}

const TableRow = styled(Flex)`
  justify-content: space-between;
`

const Divider = styled(Flex)`
  height: 1px;
  width: 100%;
  border-top: 1px solid ${({ theme }) => theme.colors.gray6};
  opacity: 0.2;
  margin: 8px 0px;
`

const StakeOverviewInfo: React.FC<IAppProps> = ({ label, value, valueType = '', valueColor, isLast, isLoading }) => {
  const { colors } = useTheme()
  return (
    <>
      <TableRow>
        <Text variant={TextVariant.BODY_SMALL} color={colors.gray6}>
          {label}
        </Text>
        {isLoading ? (
          <Flex>
            <UseAnimations animation={loading} size={16} strokeColor={colors.white3} />
          </Flex>
        ) : (
          <Text variant={TextVariant.BODY_SMALL_BOLD} color={valueColor}>
            {value} {valueType}
          </Text>
        )}
      </TableRow>
      {!isLast && <Divider />}
    </>
  )
}

export default StakeOverviewInfo
